import { useStoreValue } from '../../../../store';
import UserAvatar from '../../../UserAvatar';

const ChatMessage = ({ data }) => {
    const userData = useStoreValue('userData');
    const team = useStoreValue('team');

    const isMe = data.senderId === userData.id;
    const sender = isMe
        ? { name: userData.name, surname: userData.surname, avatarUrl: userData.profile_picture_url }
        : (() => {
            const member = team.find(m => m.senderId === data.senderId);
            return {
                name: member?.name ?? '',
                surname: member?.surname ?? '',
                avatarUrl: member?.profile_picture_url ?? null,
            };
        })();

    const time = data.createdAt
        ? new Date(data.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : '';

    return (
        <div className={['chatMessage', isMe ? 'me' : ''].join(' ')}>
            <UserAvatar url={sender.avatarUrl} name={`${sender.name} ${sender.surname}`} />
            <div className="msgWrapper">
                <div className="msgBubble">
                    <p>{data.body}</p>
                </div>
                <div className="msgMeta">
                    <span className="userName">{sender.name} {sender.surname}</span>
                    <span className="msgTime">{time}</span>
                </div>
            </div>
        </div>
    );
};

export default ChatMessage;
